export default __webpack_public_path__ + "static/media/army_s.b70bd530.png";